import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { IMAGE_BASE_URL } from 'utils/constants';

class researcher extends Component  {
    render()
    {
        if(this.props.page_path!==''){
            return (
                <a href={this.props.page_path} target='_blank'>
                    <div className="s-12 m-6 l-five" >
                        <div className="image-with-hover-overlay image-hover-zoom" title="Portfolio Image">
                            <img src={`${IMAGE_BASE_URL}/${this.props.image}`} className="full-img"/>
                        </div>
                        <div className="p-4 tm-bg-white tm-catalog-item-description" style={{position:'relative'}}>
                            <h3 className="tm-text-primary mb-3 tm-catalog-item-title"></h3>
                            
                            <p className="tm-catalog-item-text"> <span className="tm-text-secondary"></span> 
                                {this.props.name}</p>
                                
                            <div className="arrow-up"></div>    
                        </div>	
                    </div>
                </a>
            )
        }
        else{
            return (
                <Link to={`${this.props.isVietnamese? '/vi' : ''}/researchgroup/${this.props.id}`}>
                    <div className="s-12 m-6 l-five" >
                        <div className="image-with-hover-overlay image-hover-zoom"  title="Portfolio Image">
                            <img src={`${IMAGE_BASE_URL}/${this.props.image}`} className="full-img"/>
                        </div>
                        <div className="p-4 tm-bg-white tm-catalog-item-description" style={{position:'relative'}}>
                            <h3 className="tm-text-primary mb-3 tm-catalog-item-title"></h3>
                            
                            <p className="tm-catalog-item-text"> <span className="tm-text-secondary"></span> 
                                {this.props.name}</p>
                                
                            <div className="arrow-up"></div>    
                        </div>	
                    </div>
                </Link>
            )
        }
        
    }
}
export default researcher;